import React from "react";
import { CircularProgress } from "@mui/material";

import { Wrapper, ContentWrapper, IconWrapper, LabelWrapper } from "./styles";

export default function Button({
  children = "Button Name",
  disabled = false,
  loading = false,
  button,
  buttonTheme = "active",
  fontSize = "1.5rem",
  height = "2.5rem",
  width = "10.1rem",
  minWidth = "0rem",
  onClick,
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  ...rest
}) {
  const handleClick = (e) => {
    if (!loading) {
      onClick(e);
    }
  };

  return (
    <Wrapper
      button={button}
      buttonTheme={disabled ? "goback" : buttonTheme}
      disabled={disabled || loading}
      fontSize={fontSize}
      height={height}
      width={width}
      minWidth={minWidth}
      onClick={handleClick}
      {...rest}
    >
      {loading && buttonTheme === "active" ? (
        <CircularProgress color="inherit" size={24} />
      ) : (
        <ContentWrapper>
          <IconWrapper>{LeftIcon && <LeftIcon />}</IconWrapper>
          <LabelWrapper>{!!children && children}</LabelWrapper>
          <IconWrapper>{RightIcon && <RightIcon />}</IconWrapper>
        </ContentWrapper>
      )}
    </Wrapper>
  );
}
